var Grid = (function () {

    var grid,
        select,
        rootUrl = '/wp-json/',
        baseUrl,
        currentPage;
    var init = function () {
        grid = $('.content-body.grid');
        if (!grid.length) return;
        itemTpl = _.template($('#grid-item-tpl').html());
        baseUrl = rootUrl + grid.data('restbase') + '/' + grid.data('posttype')
        $(document).on('click', '.grid-pagination .next', loadMore);
        grid = grid.masonry({
            itemSelector: '.grid-item',
            percentPosition: true,
            columnWidth: '.grid-sizer',
            transitionDuration: 0
        });
        watchImagesLoaded();
        CustomSelect.init('.select-news-filter');
        initFilters();
    },
    initFilters = function () {
        select = $('.select-grid-filter').find('select');
        if (!select.length) return;
        select.on( "c-select:change", function( event, value ) {
            setFilter(value);
        });
    },
    watchImagesLoaded = function () {
        grid.imagesLoaded().progress( imageHasLoaded );
    },
    imageHasLoaded = function () {
        refreshLayout();
    },
    refreshLayout = function () {
        grid.masonry('layout');
    },
    parsePageNum = function (href) {
        if (href) {
            var res = /page\/([0-9]+)\//ig.exec(href);
            if (res && res.length > 1) {
                currentPage = parseInt(res[1]);
                return currentPage;
            }
        }
        currentPage = null;
        return currentPage;
    },
    loadItems = function (pageNum) {
        var url = grid.data('filter') ? baseUrl + '/filter/' + grid.data('filter') : baseUrl;
        $.getJSON( url, {page: pageNum}, itemsLoaded);
    },
    itemsLoaded = function( data, textStatus, request ) {
        appendItems(data);
        watchImagesLoaded();
        updateLoadMoreButton(request);
    },
    appendItems = function (itemsdata) {
        var items = [];
        _.each(itemsdata, function (item) {
            items.push(itemTpl(item));
        })
        var $content = $(items.join(''));
        watchImagesLoaded();
        $('.content-body.grid').append($content).masonry('appended', $content);

        refreshLayout();
    },
    setLoadMoreButtonInactive = function () {
        $('.grid-pagination .next').addClass('disabled');
    },
    updateLoadMoreButton = function (request) {
        $('.grid-pagination .next').removeClass('disabled');
        if (currentPage >= parseInt(request.getResponseHeader('X-WP-TotalPages'))) {
            $('.grid-pagination .next').addClass('invisible');
        } else {
            $('.grid-pagination .next').removeClass('invisible');
        }
        var href = $('.grid-pagination .next').attr('href');
        var newHref = href.replace(/page\/([0-9]+)/, 'page/'+(currentPage+1))
        $('.grid-pagination .next').attr('href', newHref)
    },
    loadMore = function (e) {
        var page = parsePageNum($(this).attr('href'));
        setLoadMoreButtonInactive();
        loadItems(page);
        e.preventDefault();

    },
    setFilter = function (value) {
        if (value != 'all') {
            grid.attr('data-filter', value );
            grid.data('filter', value );
        } else {
            grid.removeAttr('data-filter');
            grid.data('filter', null );
        }
        grid.find('.grid-item').remove();
        currentPage = 1;
        loadItems(currentPage);
    }
    return {
        init : init,
        setFilter: setFilter
    }

})();